var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnualReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F5FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 24C30.8807 24 32 22.8807 32 21.5C32 20.1193 30.8807 19 29.5 19C28.1193 19 27 20.1193 27 21.5C27 22.8807 28.1193 24 29.5 24Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18C22.8807 18 24 16.8807 24 15.5C24 14.1193 22.8807 13 21.5 13C20.1193 13 19 14.1193 19 15.5C19 16.8807 20.1193 18 21.5 18Z",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.476 28H31C33.817 28 34 30 34 30L22.235 34.525C21.448 34.828 20.57 34.785 19.816 34.408L13 31V24H14C15.105 24 17.906 24.438 19 26H22C24.209 26 26 27.791 26 30H19",
    stroke: "#3785E2",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnualReturn);
export default __webpack_public_path__ + "static/media/anual-return.40248d7e8f00e46b7a5677ff64581c46.svg";
export { ForwardRef as ReactComponent };